import { Component, OnInit } from '@angular/core';
import { AutoRefreshService } from '../../services/auto-refresh.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  autoRefreshEnabled = false;
  showToggle = false;



  constructor(
    private router: Router,
    private autoRefreshService: AutoRefreshService
  ) { }

  ngOnInit(): void {

    this.checkIfDashboard();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkIfDashboard();
      });
    }

    toggleAutoRefresh() {
      this.autoRefreshService.toggle(this.autoRefreshEnabled);
    }


    checkIfDashboard() {
      this.showToggle = this.router.url.startsWith('/dashboard');
    }


    getCurrentYear() {
    return new Date().getFullYear();
    }
  


}
